/**
 * CartPageShell — Feb 2026 (Modern Card Theme · Phase 2)
 *
 * Thin theme-aware switcher for the customer cart + checkout surface.
 * Renders CartPageModern when `ui_theme = 'modern'`, otherwise the
 * legacy CartPage (Code theme). Registered in App.js under the
 * `/customer/cart` route so both themes read the SAME test IDs and
 * hooks — no behavior fork.
 */
import { useTheme } from '../../context/ThemeContext';
import { CartPage as CartPageLegacy } from './CartPage';
import { CartPageModern } from './CartPageModern';

export function CartPageShell() {
  const { isModern } = useTheme();
  return isModern ? <CartPageModern /> : <CartPageLegacy />;
}

export default CartPageShell;
